export const GITHUB_CONNECT_CONFIRM_PATH = '/github-connect';
export type GitHubConnectFlow = 'install' | 'authorize';

export function buildGitHubConnectUrl({
  flow = 'install',
  returnUrl,
}: {
  flow?: GitHubConnectFlow;
  returnUrl?: string;
} = {}) {
  const url = new URL(GITHUB_CONNECT_CONFIRM_PATH, window.location.origin);
  url.searchParams.set('flow', flow);
  url.searchParams.set('return_to', returnUrl ?? window.location.href);
  return url.toString();
}
